<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  head: {
    link: [
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/icon?family=Material+Icons"
      }
    ]
  },
};
</script>

<style lang="scss">
@import "~/assets/scss/main.scss";
</style>
